export const selectQuery = (state) => state.query;
export const selectEnableQuerySyntax = (state) => state.query?.enableQuerySyntax;
